import React from 'react';
import { StyledList } from '@zillow/constellation';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItem from './ListItem.js';
import { ListContext } from './ListContext.js';
import { negativeMarginMixin } from '../../mixins/negativeMarginMixin.js';

/* eslint-disable no-confusing-arrow */
var MyStyledList = /*#__PURE__*/styled(StyledList).withConfig({
  componentId: "sc-9a1gid-0"
})(["&&&&&{", "}color:inherit;"], negativeMarginMixin);
var List = function List(props) {
  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MyStyledList, props));
};
List.Item = ListItem;
List.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.shape({}),
  appearance: PropTypes.oneOf(['number', 'checkmark', 'bullet', 'horizontalTable', 'none']),
  verticalSpace: PropTypes.oneOf([0, 'xs', 'sm', 'md', 'lg', 'xl'])
} : {};
List.defaultProps = {
  appearance: 'bullet',
  verticalSpace: 'none'
};
var List$1 = List;

export { List$1 as default };
